export function bucketsToMap<T>(
  buckets: { val: T; count: number }[],
  baseMap = new Map(),
): Map<T, number> {
  return buckets.reduce((map: Map<T, number>, { count, val }) => {
    map.set(val, count);
    return map;
  }, baseMap);
}
